import { InvoiceDetailsPagePolaris } from "../components/seller/invoices/InvoiceDetailsPagePolaris";
import MainLayout from "../layout/MainLayout";
import AddCampaignProduct from "../pages/seller/AddCampaignProduct";
import AddProductPageV2 from "../pages/seller/AddProductV2";
import { CloneProductCampaign } from "../pages/seller/CloneProductCampaign";
import { CloneProductV2 } from "../pages/seller/CloneProductV2";
import EditProductCampaign from "../pages/seller/EditProductCampaign";
import EditProductPageV2 from "../pages/seller/EditProductV2";
import { InvoicesPagePolaris } from "../pages/seller/InvoicesPagePolaris";
import { OrdersPagePolaris } from "../pages/seller/OrdersPagePolaris";
import { OrdersPagePolaris2 } from '../pages/seller/OrdersPagePolaris2';
import { ProductsPagePolaris } from "../pages/seller/ProductsPagePolaris";
import { TEAM_ROLE, USER_ROLE } from "../variable";

const pathname = "/platform-manager";
const routes = [
    {
        path: `${pathname}/products`,
        exact: true,
        component: ProductsPagePolaris,
        layout: MainLayout,
        title: "Products",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },

    {
        path: `${pathname}/products/edit/:id`,
        exact: true,
        component: EditProductPageV2,
        layout: MainLayout,
        title: "Edit Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/add-campaign/:id`,
        exact: true,
        component: AddCampaignProduct,
        layout: MainLayout,
        title: "Add Campaign Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/clone-campaign`,
        exact: true,
        component: CloneProductCampaign,
        layout: MainLayout,
        title: "Clone Campaign Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/campaign/:id`,
        exact: true,
        component: EditProductCampaign,
        layout: MainLayout,
        title: "Edit Product Campaign",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/add-campaign`,
        exact: true,
        component: AddCampaignProduct,
        layout: MainLayout,
        title: "Add Campaign Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/add`,
        exact: true,
        component: AddProductPageV2,
        layout: MainLayout,
        title: "Add Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/add/:id`,
        exact: true,
        component: AddProductPageV2,
        layout: MainLayout,
        title: "Add Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/products/clone`,
        exact: true,
        component: CloneProductV2,
        layout: MainLayout,
        title: "Clone Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/orders2`,
        exact: true,
        component: OrdersPagePolaris,
        layout: MainLayout,
        title: "Orders",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/orders`,
        exact: true,
        component: OrdersPagePolaris2,
        layout: MainLayout,
        title: "Orders",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/billings/invoices`,
        exact: true,
        component: InvoicesPagePolaris,
        title: "Invoices",
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
    {
        path: `${pathname}/billings/invoice/:id`,
        exact: true,
        component: InvoiceDetailsPagePolaris,
        title: "Invoice Details",
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.PlatformManager,
    },
];

export default routes;
